export const sendSingleEvent = (clickEvent: Record<string, any>) => {
  if (window && window.na && clickEvent?.event_name) {
    window.na.sendEvent(clickEvent.event_name, clickEvent);
  }
};
